// export const passwordRegx = /^(?=.*\d)(?=.*[!@#$%^&*])(?=.*[a-z])(?=.*[A-Z]).{6,12}$/;
export const passwordRegx = /^(?=.*\d)(?=.*[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?`~])(?=.*[a-z])(?=.*[A-Z]).{6,30}$/  /* allow all scpecial charactor */
export const GuidRegex=/^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/;
/** Local-part allows common email specials but rejects curly braces ({}) and other invalid chars like ()[]. */
export const emailRegex = /^[A-Z0-9.!#$%&'*+-/=?^_`|~]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i;
export const requiredFieldREgex=/^[\s\t\r\n]*\S+/ig;

/**
 * Matches emoji / pictographic characters (incl. variation selectors, ZWJ, keycap
 * and regional-indicator flags). Digits and plain punctuation are not matched.
 * Built via RegExp constructor so it does not depend on the TS compile target.
 */
const EMOJI_REGEX = new RegExp(
  "[\\p{Extended_Pictographic}\\p{Emoji_Presentation}\\u{1F1E6}-\\u{1F1FF}\\u{1F3FB}-\\u{1F3FF}\\u{FE0F}\\u{200D}\\u{20E3}]",
  "u"
);

/** True when the value contains at least one emoji character. */
export function containsEmoji(value: string): boolean {
  return EMOJI_REGEX.test(value || '');
}

/** Full name: letters, spaces, hyphens, apostrophes only (no digits/emoji/other symbols). */
export const FULL_NAME_CHARS_REGEX = /^[a-zA-Z\s'-]+$/;
/** Strip anything not allowed in a person name while typing. */
export const FULL_NAME_ALLOWED_CHARS_REGEX = /[^a-zA-Z\s'-]/g;
export const FULL_NAME_MIN_LENGTH = 2;
export const FULL_NAME_MAX_LENGTH = 35;

/** Trim edges and collapse repeated spaces. */
export function normalizeFullName(value: string): string {
  return (value || '').trim().replace(/\s+/g, ' ');
}

/** Live input filter: drop illegal chars, collapse spaces, no leading space. */
export function filterFullNameInput(value: string, max = FULL_NAME_MAX_LENGTH): string {
  return (value || '')
    .replace(FULL_NAME_ALLOWED_CHARS_REGEX, '')
    .replace(/^\s+/g, '')
    .replace(/\s+/g, ' ')
    .slice(0, max);
}

/**
 * Validate a full name. Returns '' when valid.
 * @param fieldLabel e.g. "Full name" / "First name"
 */
export function validateFullNameValue(
  value: string,
  fieldLabel = 'Full name',
  options?: { min?: number; max?: number }
): string {
  const min = options?.min ?? FULL_NAME_MIN_LENGTH;
  const max = options?.max ?? FULL_NAME_MAX_LENGTH;
  const normalized = normalizeFullName(value);

  if (!normalized) {
    return `Please enter your ${fieldLabel.toLowerCase()}`;
  }
  if (!FULL_NAME_CHARS_REGEX.test(normalized)) {
    return `${fieldLabel} can only contain letters, spaces, hyphens, and apostrophes`;
  }
  // Must include at least one letter (rejects names that are only spaces/hyphens/apostrophes)
  if (!/[a-zA-Z]/.test(normalized)) {
    return `${fieldLabel} must include letters`;
  }
  if (normalized.length < min) {
    return `${fieldLabel} must be at least ${min} characters`;
  }
  if (normalized.length > max) {
    return `${fieldLabel} must not exceed ${max} characters`;
  }
  return '';
}
